import { alpha } from '@mui/material/styles';
// import { create } from 'lodash';

// ----------------------------------------------------------------------

function createGradient(color1, color2) {
  return `linear-gradient(to right, ${color1}, ${color2})`;
}

// SETUP COLORS
const GREY = {
  0: '#FFFFFF',
  100: '#F9FAFB',
  200: '#F4F6F8',
  300: '#DFE3E8',
  400: '#C4CDD5',
  500: '#919EAB',
  600: '#637381',
  700: '#454F5B',
  800: '#212B36',
  900: '#161C24',
  500_8: alpha('#919EAB', 0.08),
  500_12: alpha('#919EAB', 0.12),
  500_16: alpha('#919EAB', 0.16),
  500_24: alpha('#919EAB', 0.24),
  500_32: alpha('#919EAB', 0.32),
  500_48: alpha('#919EAB', 0.48),
  500_56: alpha('#919EAB', 0.56),
  500_80: alpha('#919EAB', 0.8),
};

const TECNO = {
  blue: '#00678D',
  cinza_claro: '#DAE0E3',
  blue_claro_transp: '#99dae0e3',
  cinza_escuro: '#b9bfc4',
  background: '#fcfdfd',
  vermelho: '#C8191B',
};

const DARK = {
  // background
  primary: '#36373a',
  default: '#121212',
  paper: '#121212',
  divider: 'rgba(255, 255, 255, 0.12)',
  // buttons
  active: '#fff',
  hover: 'rgba(255, 255, 255, 0.08)',
  selected: 'rgba(255, 255, 255, 0.16)',
  disabled: 'rgba(255, 255, 255, 0.3)',
  disabledBackground: 'rgba(255, 255, 255, 0.12)',
};

// };
const PRIMARY = {
  lighter: '#CCEAF1',
  light: '#99D5E2',
  main: '#00678D',
  dark: '#004A67',
  darker: '#003046',
  contrastText: '#fff',
};

const SECONDARY = {
  lighter: '#C8FACD',
  light: '#5BE584',
  main: '#00AB55',
  dark: '#007B55',
  darker: '#005249',
  contrastText: '#fff',
};
const INFO = {
  lighter: '#D0F2FF',
  light: '#74CAFF',
  main: '#1890FF',
  dark: '#0C53B7',
  darker: '#04297A',
  contrastText: '#fff',
};
const SUCCESS = {
  lighter: '#E9FCD4',
  light: '#AAF27F',
  main: '#54D62C',
  dark: '#229A16',
  darker: '#08660D',
  contrastText: GREY[800],
};
const WARNING = {
  lighter: '#FFF7CD',
  light: '#FFE16A',
  main: '#FFC107',
  dark: '#B78103',
  darker: '#7A4F01',
  contrastText: GREY[800],
};
const ERROR = {
  lighter: '#FFE7D9',
  light: '#FFA48D',
  main: '#FF4842',
  dark: '#B72136',
  darker: '#7A0C2E',
  contrastText: '#fff',
};

const GRADIENTS = {
  primary: createGradient(PRIMARY.light, PRIMARY.main),
  info: createGradient(INFO.light, INFO.main),
  success: createGradient(SUCCESS.light, SUCCESS.main),
  warning: createGradient(WARNING.light, WARNING.main),
  error: createGradient(ERROR.light, ERROR.main),
  dark: createGradient(DARK.primary, DARK.disabledBackground),
};

const CHART_COLORS = {
  violet: ['#826AF9', '#9E86FF', '#D0AEFF', '#F7D2FF'],
  outro: ['#90ebe4', '#8ac7df', '#84a2da', '#7f7fd5'],
  blue: ['#2D99FF', '#83CFFF', '#A5F3FF', '#CCFAFF'],
  green: ['#2CD9C5', '#60F1C8', '#A4F7CC', '#C0F2DC'],
  yellow: ['#FFE700', '#FFEF5A', '#FFF7AE', '#FFF3D6'],
  red: ['#FF6C40', '#FF8F6D', '#FFBD98', '#FFF2D4'],
};

const palette = {
  common: { black: '#000', white: '#fff' },
  tecno: { ...TECNO },
  dark: { ...DARK },
  primary: { ...PRIMARY },
  secondary: { ...SECONDARY },
  info: { ...INFO },
  success: { ...SUCCESS },
  warning: { ...WARNING },
  error: { ...ERROR },
  grey: GREY,
  gradients: GRADIENTS,
  chart: CHART_COLORS,
  divider: DARK.divider,
  text: { primary: '#333', secondary: '#6A6A6A', disabled: GREY[500] },
  background: { paper: '#fff', default: '#eee ', neutral: GREY[200] },
  action: {
    active: DARK.active,
    hover: DARK.hover,
    selected: DARK.selected,
    disabled: DARK.disabled,
    disabledBackground: DARK.disabledBackground,
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

export default palette;
